<!-- MODO ESTRICTO (password con reglas) -->
@if (estricto) {
  <div
    class="input-container relative mt-6 rounded-t-md"
    [ngClass]="{ 'border-t-red-600 border-r-red-600 border-l-red-600 border': (showError && isEmpty(valor)) || hardError }"
  >
    <p-floatLabel class="w-full">
      <input
        pInputText
        [type]="tipo"
        [id]="id"
        [(ngModel)]="valor"
        (ngModelChange)="stringValido($event)"
        (focus)="show = true"
        (blur)="sendOnBlur($event); show = false; trim()"
        [readonly]="readonly"
        [disabled]="desactivado"
  [attr.maxlength]="maxLength ?? null"
        [ngClass]="{ 'p-invalid': (showError && isEmpty(valor)) || hardError }"
        autocomplete="new-password"
      />
      <label [for]="id">{{ etiqueta }}</label>
    </p-floatLabel>
    @if (contrasenia) {
      <img
        (click)="toggleContrasenia()"
        [src]="icon.icon"
        [alt]="icon.alt"
        width="20"
        class="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer"
      />
    }
  </div>
  <div class="hide" [ngClass]="{ show: (showError && isEmpty(valor)) || hardError }">
    <div>
      <small class="flex justify-start items-center text-red-600 mt-1">
        {{ mensajeError }}
      </small>
    </div>
  </div>
  <!-- Reglas de contraseña -->
  <div class="flex flex-col items-start mt-2 space-y-1">
    <small [class.text-red-600]="!hasUpperCase" [class.text-green-600]="hasUpperCase">
      <img [src]="hasUpperCase ? '/svg/check.svg' : '/svg/close.svg'" alt width="12" class="inline mr-1" />
      <b>Debe contener 1 letra mayúscula</b>
    </small>
    <small [class.text-red-600]="!hasSpecialChar" [class.text-green-600]="hasSpecialChar">
      <img [src]="hasSpecialChar ? '/svg/check.svg' : '/svg/close.svg'" alt width="12" class="inline mr-1" />
      <b>Debe contener al menos 1 carácter especial</b>
    </small>
    <small [class.text-red-600]="!isLength" [class.text-green-600]="isLength">
      <img [src]="isLength ? '/svg/check.svg' : '/svg/close.svg'" alt width="12" class="inline mr-1" />
      <b>8 caracteres como mínimo</b>
    </small>
    <small [class.text-red-600]="!hasNumbers" [class.text-green-600]="hasNumbers">
      <img [src]="hasNumbers ? '/svg/check.svg' : '/svg/close.svg'" alt width="12" class="inline mr-1" />
      <b>4 números como mínimo</b>
    </small>
    <small [class.text-red-600]="!nonConsecutive || !nonRepetitive" [class.text-green-600]="nonConsecutive && nonRepetitive">
      <img [src]="(nonConsecutive && nonRepetitive) ? '/svg/check.svg' : '/svg/close.svg'" alt width="12" class="inline mr-1" />
      <b>Números no consecutivos (ej. 1234/4321) ni repetitivos (ej. 1111)</b>
    </small>
  </div>
}
<!-- MODO NORMAL -->
@else {
  <div
    class="input-container relative mt-6 rounded-t-md"
    [ngClass]="{ 'border-t-red-600 border-r-red-600 border-l-red-600 border': (showError && isEmpty(valor)) || hardError }"
  >
    <p-floatLabel class="w-full">
      <input
        pInputText
        [type]="tipo"
        [id]="id"
        #input
        [(ngModel)]="valor"
        (focus)="show = true"
        (blur)="sendOnBlur($event); show = false; trim()"
        [readonly]="readonly"
        [disabled]="desactivado"
        (input)="replace(input)"
        [max]="max"
  [attr.maxlength]="maxLength ?? null"
        [ngClass]="{ 'p-invalid': (showError && isEmpty(valor)) || hardError }"
        autocomplete="off"
      />
      <label [for]="id">{{ etiqueta }}</label>
    </p-floatLabel>
    @if (contrasenia) {
      <img
        (click)="toggleContrasenia()"
        [src]="icon.icon"
        [alt]="icon.alt"
        width="20"
        class="absolute top-1/2 -translate-y-1/2 right-2 cursor-pointer"
      />
    }
  </div>
  <div class="hide" [ngClass]="{ show: (showError && isEmpty(valor)) || hardError }">
    <div>
      <small class="flex justify-start items-center text-red-600 mt-1">
        {{ mensajeError }}
      </small>
    </div>
  </div>
}
